import { groupBracketsByTournament } from './groupTournaments'

// Every group tournament has a prize (owner 2026-10-07): when the group owner
// hasn't added one for a tournament, the default is "Bragging Rights" and the
// dub Champ crown. Returns the group's tournaments (get_group_brackets rows)
// that have no group prize at any level, in the group page's order.
export function tournamentsWithoutPrize(brackets, prizes, now = new Date()) {
  const withPrize = new Set((prizes || []).map((p) => p.tournament_id))
  return groupBracketsByTournament(brackets, now).filter((t) => !withPrize.has(t.id))
}
